export default __webpack_public_path__ + "static/media/clicking.14826e5c.svg";